import { keepPreviousData, useQuery } from '@tanstack/react-query'

import type { AgriMaterialUsageParams } from '@/lib/api/agri-material-usage-api'
import { agriMaterialUsageApi } from '@/lib/api/agri-material-usage-api'

const STALE_MS = 5 * 60 * 1000

export const agriMaterialUsageKeys = {
    all: ['agri-material-usage'] as const,
    list: (params: AgriMaterialUsageParams) =>
        [...agriMaterialUsageKeys.all, 'list', params] as const,
}

export function useAgriMaterialUsage(
    params: AgriMaterialUsageParams,
    options?: { enabled?: boolean },
) {
    return useQuery({
        enabled: options?.enabled ?? true,
        queryKey: agriMaterialUsageKeys.list(params),
        queryFn: async () => {
            const res = await agriMaterialUsageApi.list(params)
            return res.data ?? []
        },
        staleTime: STALE_MS,
        placeholderData: keepPreviousData,
    })
}
